export const COMPLETE = 'Complete';